var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelTwitterSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 11,
  viewBox: "0 0 13 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.4 5.2 11.3 1h-1L7 4.8 4.3 1H1.2l4.3 6-4.3 4h1L7 7.2 9.7 11h3.1zM6.2 6.5 5.8 6 2.7 1.8h1.5L7 5.7l.4.6 3.6 5H9.5z"
})));
export default SvgChannelTwitterSm;